// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  url: 'http://svc1.acessorh.localhost',
  url_benefits: 'http://benefits.acessorh.localhost/v1',
  url_ongoing: 'http://localhost:8087/api/v1',
  cdn_url: 'http://cdn1.acessorh.localhost',
  identity_url: 'http://identity.acesso.localhost',
  base_url: 'http://benefits.acessorh.localhost',
  sign_url: 'http://localhost:3000',
  sign_id: 'DB8EF2DD966F2CE9F3237F1A1746143B346393D373C7268FFC32759DE06597EA',
  redirect_uri: 'http://benefits.acessorh.localhost/preauthorize',
  segment_key: 'aJSx6ITwDTBcFEq6je022Y0UrC52Khm1',
  admission_url: 'http://admin.acessorh.localhost',
  collaborator_url: 'http://admin.acessorh.localhost',
  sentry_key: 'https://a423660f3a134dc3b3e083a5fccfd9e2@o939397.ingest.sentry.io/4504334316797952',
  launchDarklyClientId: '63ea5db5e87179139977b661',
  mixpanel_token: 'f4069d9b550ea08e34089810c2abd5be',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
